import React, { useState } from 'react';
import { API, authFetch } from '../utils/api';

// 평점 작성 모달 — 별점 1~5 + 코멘트
function AuctionReviewModal(props){
  var auction=props.auction||{};
  var onClose=props.onClose;
  var onSuccess=props.onSuccess;

  var[score,setScore]=useState(0);
  var[hoverScore,setHoverScore]=useState(0);
  var[comment,setComment]=useState('');
  var[submitting,setSubmitting]=useState(false);
  var[error,setError]=useState('');

  var modelLabel=(auction.car&&auction.car.model)||auction.title||'경매 차량';
  var winAmount=auction.winAmount||(auction.liveStats&&auction.liveStats.highestBid)||0;
  var winMan=Math.round(winAmount/10000).toLocaleString();

  var handleSubmit=function(){
    if(submitting)return;
    if(!score||score<1||score>5){
      setError('별점을 선택해주세요');
      return;
    }
    setSubmitting(true);
    setError('');
    authFetch(API+'/auctions/'+auction.id+'/review',{
      method:'POST',
      body:JSON.stringify({score:score,comment:comment})
    })
      .then(function(r){return r.json()})
      .then(function(d){
        if(d&&d.success){
          if(onSuccess)onSuccess(d.data);
        }else{
          setError((d&&d.error)||'후기 등록 실패');
        }
      })
      .catch(function(){setError('서버 연결 실패')})
      .then(function(){setSubmitting(false)});
  };

  var displayStar=hoverScore||score;

  return (
    <div onClick={function(){if(!submitting)onClose()}}
      style={{position:'fixed',inset:0,background:'rgba(15,23,42,0.6)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9998,padding:16}}>
      <div onClick={function(e){e.stopPropagation()}}
        style={{background:'#fff',borderRadius:16,width:'100%',maxWidth:440,maxHeight:'90vh',overflowY:'auto',boxShadow:'0 20px 60px rgba(0,0,0,0.3)'}}>

        {/* 헤더 */}
        <div style={{padding:'16px 20px',borderBottom:'1px solid #e5e7eb',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
          <div style={{fontSize:16,fontWeight:800,color:'#1B3A5C',display:'flex',alignItems:'center',gap:6}}>
            <span>⭐</span><span>후기 작성</span>
          </div>
          <button onClick={onClose} disabled={submitting}
            style={{background:'none',border:'none',fontSize:20,cursor:submitting?'wait':'pointer',color:'#94a3b8',padding:4}}>✕</button>
        </div>

        {/* 본문 */}
        <div style={{padding:'20px'}}>
          {/* 차량 요약 */}
          <div style={{padding:'12px',background:'#f8fafc',borderRadius:8,marginBottom:18,textAlign:'center'}}>
            <div style={{fontSize:14,fontWeight:700,color:'#0f172a'}}>{modelLabel}</div>
            {winAmount>0&&(
              <div style={{fontSize:11,color:'#64748b',marginTop:4}}>
                낙찰가 <strong style={{color:'#047857'}}>{winMan}만원</strong>
              </div>
            )}
          </div>

          {/* 별점 */}
          <div style={{marginBottom:18}}>
            <div style={{fontSize:11,fontWeight:700,color:'#64748b',marginBottom:10,textAlign:'center'}}>
              거래는 어떠셨나요? <span style={{color:'#ef4444'}}>*</span>
            </div>
            <div style={{display:'flex',justifyContent:'center',gap:6}}>
              {[1,2,3,4,5].map(function(n){
                var filled=n<=displayStar;
                return (
                  <button key={n}
                    onClick={function(){setScore(n);setError('')}}
                    onMouseEnter={function(){setHoverScore(n)}}
                    onMouseLeave={function(){setHoverScore(0)}}
                    disabled={submitting}
                    style={{background:'none',border:'none',fontSize:40,cursor:submitting?'wait':'pointer',padding:'2px 4px',color:filled?'#F59E0B':'#cbd5e1',transition:'color 0.15s, transform 0.15s',transform:displayStar===n?'scale(1.1)':'scale(1)'}}>
                    {filled?'★':'☆'}
                  </button>
                );
              })}
            </div>
            {displayStar>0&&(
              <div style={{fontSize:11,color:'#F59E0B',fontWeight:700,textAlign:'center',marginTop:6}}>
                {displayStar===5?'⭐ 매우 만족':displayStar===4?'😊 만족':displayStar===3?'🙂 보통':displayStar===2?'😕 아쉬움':'😞 불만족'}
              </div>
            )}
          </div>

          {/* 코멘트 */}
          <div style={{marginBottom:14}}>
            <label style={{display:'block',fontSize:11,fontWeight:700,color:'#64748b',marginBottom:6}}>후기 (선택)</label>
            <textarea value={comment} onChange={function(e){setComment(e.target.value.substring(0,500))}}
              disabled={submitting}
              placeholder="거래 상대방에 대한 후기를 자유롭게 작성해주세요 (500자 이내)"
              style={{width:'100%',minHeight:100,padding:'10px 12px',border:'1px solid #cbd5e1',borderRadius:6,fontSize:12,resize:'vertical',fontFamily:'inherit',outline:'none',boxSizing:'border-box',lineHeight:1.5}}/>
            <div style={{fontSize:10,color:'#94a3b8',marginTop:4,textAlign:'right'}}>{comment.length}/500</div>
          </div>

          {/* 안내 */}
          <div style={{padding:'10px 12px',background:'#fff7ed',border:'1px solid #fed7aa',borderRadius:8,fontSize:11,color:'#9a3412',lineHeight:1.6,marginBottom:14}}>
            ℹ️ 후기는 한 번만 작성할 수 있으며, 작성 후 수정/삭제할 수 없습니다
          </div>

          {/* 에러 */}
          {error&&(
            <div style={{padding:'10px 12px',background:'#fef2f2',border:'1px solid #fecaca',borderRadius:8,fontSize:12,color:'#dc2626',marginBottom:12}}>
              {error}
            </div>
          )}

          {/* 제출 버튼 */}
          <button onClick={handleSubmit} disabled={submitting||!score}
            style={{width:'100%',padding:'13px 0',background:(submitting||!score)?'#cbd5e1':'#1B3A5C',color:'#fff',border:'none',borderRadius:8,fontSize:14,fontWeight:800,cursor:(submitting||!score)?'not-allowed':'pointer'}}>
            {submitting?'등록 중...':'후기 등록'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AuctionReviewModal;
